import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";

export const Grid = styled(Box)<{ theme: Theme }>(({ theme }) => ({
    marginRight: theme.spacing(10),
    marginLeft: theme.spacing(10),

    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing(2),

    // fondo como el screenshot
    backgroundColor: "#f2f2f2",
    padding: theme.spacing(2),

    // responsive
    [theme.breakpoints.down("md")]: {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        gridTemplateColumns: "1fr",
    },
}));
export const StyledBoxCalendar = styled(Box)<{ theme: Theme }>(({ theme }) => ({
    backgroundColor: "#fff",
    borderRadius: theme.spacing(1.25),
    overflow: "hidden",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    border: "1px solid rgba(0,0,0,0.06)",
}));